import React from "react";
import DiscordIcon from "../../assets/images/social/discord.webp";
import TwitterIcon from "../../assets/images/social/twitter.webp";
import YoutubeIcon from "../../assets/images/social/youtube.webp";
import MediumIcon from "../../assets/images/social/medium.webp";
import DiscordSelectedIcon from "../../assets/images/social/discord-selected.webp";
import TwitterSelectedIcon from "../../assets/images/social/twitter-selected.webp";
import YoutubeSelectedIcon from "../../assets/images/social/youtube-selected.webp";
import MediumSelectedIcon from "../../assets/images/social/medium-selected.webp";

function Index({class1="w-75",top1=4,left1=6}) {
  return (
    <>
     <ul className="list-unstyled mb-0">
                    <li className="text-center">
                      <a
                        href={process.env.REACT_APP_DISCORD_LINK}
                        target={"_blank"}
                      >
                        <div className="dfws-card">
                          <img
                className={`img-fluid ${class1}`}
                            src={DiscordIcon}
                            alt={"Discord"}
                          />
              <img
                className={`img-fluid img-top ${class1}`}
                             style={{top : top1 , left:left1}}
                            src={DiscordSelectedIcon}
                            alt={""}
                          />
                        </div>
                      </a>
                    </li>
                    
                    <li className="text-center">
                      <a
                        href={process.env.REACT_APP_YOUTUBE_LINK}
                        target={"_blank"}
                      >
                        <div className="dfws-card">
                          <img
                           className={`img-fluid ${class1}`}
                            src={YoutubeIcon}
                            alt={"Discord"}
                          />
                          <img
                            className={`img-fluid img-top ${class1}`}      style={{top : top1 , left:left1}}
                            src={YoutubeSelectedIcon}
                            alt={""}
                          />
                        </div>
                      </a>
                    </li>
                    <li className="text-center">
                      <a
                        href={process.env.REACT_APP_TWITTER_LINK}
                        target={"_blank"}
                      >
                        <div className="dfws-card">
                          <img
                            className="img-fluid w-50"
                            src={TwitterIcon}
                            alt={"Discord"}
                          />
                          <img
                className="img-fluid img-top  w-50" style={{ top: 4, left: 8 }}
                            src={TwitterSelectedIcon}
                            alt={""}
                          />
                        </div>
                      </a>
                    </li>
                    <li className="text-center">
                      <a
                        href={process.env.REACT_APP_MEDIUM_LINK}
                        target={"_blank"}
                      >
                        <div className="dfws-card">
                          <img
                             className={`img-fluid ${class1}`}
                            src={MediumIcon}
                            alt={"Medium"}
                          />
                          <img
                            className={`img-fluid img-top ${class1}`}     style={{top : top1 , left:left1}}
                            src={MediumSelectedIcon}
                            alt={""}
                          />
                        </div>
                      </a>
                    </li>
                  </ul>
      </>
  );
}

export default Index;
